<template>
  <v-select
      prepend-inner-icon="sr-icon-globe"
      v-model="currentLang"
      :items="langList"
      class="lang-select global-select"
      attach=".lang-select"
      :menu-props="{ bottom: true, offsetY: true }"
      @change="langChange($event)"
      hide-selected
  />
</template>

<script>
  import { LANG } from '@/constants';
  import { mapGetters } from 'vuex';
  import { SETTINGS_GETTERS, SETTINGS_MUTATIONS } from "@/store/modules/settings";

  export default {
    name: "CurrencySelect",
    data() {
      return {
        currentLang: this.lang,
      }
    },
    mounted() {
      if (!this.lang) {
        this.lang =  this.setLang();
      }
      this.currentLang = this.lang;
    },
    created() {
      this.$i18n.locale = this.lang.toLowerCase();
    },
    computed: {
      ...mapGetters('settings', { lang: SETTINGS_GETTERS.LANG }),
      langList() {
        return [
          { text: this.$t('lang.ru'), value: LANG.RU },
          { text: this.$t('lang.ua'), value: LANG.UA },
          { text: this.$t('lang.en'), value: LANG.EN }
        ]
      },
    },
    methods: {
      langChange(lang) {
        this.$store.commit(`settings/${SETTINGS_MUTATIONS.SET_LANG}`, lang);
        this.$i18n.locale = lang.toLowerCase();

        let siteLang = LANG.SITE_LANG_UA;
        if(lang === LANG.UA) {
          siteLang = LANG.SITE_LANG_UA;
        } else if(lang === LANG.RU) {
          siteLang = LANG.SITE_LANG_RU;
        } else if(lang === LANG.EN) {
          siteLang = LANG.SITE_LANG_EN;
        };
        document.cookie = `site_lang=${siteLang}`;
      }
    }
  }
</script>
